import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  icon: {
    marginRight: theme.spacing.unit * 2,
  },
  heroUnit: {
    backgroundColor: theme.palette.background.paper,
  },
  heroContent: {
    maxWidth: 600,
    margin: '0 auto',
    padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
  },
  heroButtons: {
    marginTop: theme.spacing.unit * 4,
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardGrid: {
    padding: `${theme.spacing.unit * 8}px 0`,
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  footer: {
    background: 'rgba(230, 70, 38, 0.95)',
    padding: theme.spacing.unit * 3,
    textAlign: "center",
    margin: "50px 0px 0px 0px",
  },
  // avatar: {
  //   margin:10,

  // }
});


class Footer extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
      <footer className={classes.footer} style={{ background: '#2E3B55' }} >
            <Typography variant="title" align="center" color="textPrimary" gutterBottom>
              Ponciano Vieira
              </Typography>
            <Typography variant="caption" align="center" color="textSecondary" component="p">
              All Copyrights are reserved
              </Typography>
        </footer>
          {/* End footer */}
      </div>
    )
  }
}

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js